<template>
  <div>
    <NuxtLoadingIndicator color="#FF5F00" />
    <NuxtPage />
  </div>
</template>
<script lang="ts" setup>
</script>
